<template>
  <div style="position: fixed; bottom: 10px; left: 10px; z-index: 1000">
    <template v-for="current in requestsList">
      <v-chip
        :key="current.id"
        v-if="current.loaded"
        :color="current.active ? 'opposite' : null"
        class="mr-1 mt-1 elevation-2"
        close
        close-icon="close"
        @click:close="removeCurrent(current.id)"
        @click.stop="setCurrentActive(current.data)"
      >
        <v-icon
          small
          :color="current.active ? current.color : null"
          class="mr-2"
        >
          {{ generateMessage(`requests.tab.${current.icon}`) }}
        </v-icon>
        <span class="font-weight-bold">{{ current.property }}</span>
        <span class="mx-1">| {{ current.id }} |</span>
        <span
          class="font-weight-bold"
          :class="{ [`${current.color}--text`]: current.active }"
        >
          {{ generateMessage(`requests.tab.${current.message}`) }}
        </span>
      </v-chip>
    </template>
    <v-chip
      v-for="current in PEMcurrents"
      :key="current.id"
      close
      close-icon="close"
      class="mr-1 mt-1 elevation-2"
      :color="current.id === openedCurrent ? 'opposite' : null"
      @click:close="removePEMCurrent(current)"
      @click.stop="addPEMCurrent(current)"
    >
      <v-icon
        small
        class="mr-2"
        :color="current.id === openedCurrent ? 'primary' : null"
      >
        {{ generateMessage('alerts.icon') }}
      </v-icon>
      <span class="font-weight-bold">{{ current.name }}</span>
    </v-chip>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { generateMessage } from '@/utils/i18n';

const { mapGetters, mapActions } = createNamespacedHelpers('requests');
const mapPEMGetters = createNamespacedHelpers('sensors/properties').mapGetters;
export default {
  name: 'custom-selected-currents',
  computed: {
    ...mapGetters(['currents', 'active']),
    ...mapPEMGetters({ PEMcurrents: 'all', PEMactive: 'current' }),
    openedModal() {
      const route = this.$route.name;
      const selected = this.$store.getters['boilerplate/isOpen'].find(
        (item) => item.route === route
      );
      return selected ? selected.component : null;
    },
    openedCurrent() {
      if (this.openedModal === 'RequestDialog') {
        return this.active.id;
      }
      if (this.openedModal === 'PropertyDialog') {
        return this.PEMactive;
      }
      return null;
    },
    requestsList() {
      return this.currents.map((request) => ({
        loaded: request.data.id,
        active: request.id === this.openedCurrent,
        icon:
          request.data.status === '1' && request.data.rejected === 'N'
            ? 'icon_untreated'
            : 'icon_treated',
        color:
          request.data.status === '1' && request.data.rejected === 'N'
            ? 'warning'
            : 'success',
        message:
          request.data.status === '1' && request.data.rejected === 'N'
            ? 'msg_untreated'
            : 'msg_treated',
        property: request.data.property_shortname,
        id: request.id,
        data: request.data,
      }));
    },
  },
  methods: {
    generateMessage,
    ...mapActions(['setCurrentActive', 'removeCurrent']),
    addPEMCurrent(item) {
      return this.$store.dispatch(`sensors/properties/setModalOpened`, {
        property_id: item.id,
        property_shortname: item.name,
        component: 'PropertyDialog',
      });
    },
    removePEMCurrent(item) {
      return this.$store.dispatch(`sensors/properties/remove`, item.id);
    },
  },
};
</script>
